import { render, staticRenderFns } from "./UserTop.vue?vue&type=template&id=99562544&scoped=true"
import script from "./UserTop.vue?vue&type=script&lang=js"
export * from "./UserTop.vue?vue&type=script&lang=js"
import style0 from "./UserTop.vue?vue&type=style&index=0&id=99562544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99562544",
  null
  
)

export default component.exports